:host {
  display: block;
}

.vs-marquee-wrapper .vs-marquee-item {
  word-break: break-word !important;
}